import React, { Fragment } from 'react';
import { Form, Header } from 'semantic-ui-react';
import Field from '../Field';
import VerificationFormField from '../VerificationFormField';
import withVericationForm from './withVericationForm';
import yup from 'yup';

const ERROR_REQUIRED = 'This field is required'

class WaiverForm extends React.PureComponent {

  _onChange = (e, {name, value} ) => this.props.onChange(this.props.documentId, name, value)

  render = () => {
    const {
      onBlur,
      values,
      touched
    } = this.props;

    return (
      <Fragment>
        <Header>Waiver</Header>
        <Form>
          <Field
            touched={touched.validFlightNumber}
          >
            <VerificationFormField
              name="signedWaiver"
              value={values.signedWaiver}
              onChange={this._onChange}
              onBlur={onBlur.bind(this, 'signedWaiver')}>

              <p>Waiver signed </p>
            </VerificationFormField>
          </Field>
        </Form>
      </Fragment>
    )
  }
}

const formikConfig = {
  mapPropsToValues: props => {
    return {...props.formValues}
  },
  validationSchema: () => {
    return yup.object().shape({
      signedWaiver: yup.boolean().required(ERROR_REQUIRED)
    })
  }
}

export default withVericationForm(formikConfig, ['signedWaiver'])(WaiverForm)



// WEBPACK FOOTER //
// ./src/component/verification_forms/WaiverForm.js